import { lazy } from 'react';

const ConferenceSchoolsModal = lazy(
  () => import('./components/ConferenceSchoolsModal'),
);
const FavoriteSchoolModal = lazy(
  () => import('modules/SchoolProfile/modals/FavoriteSchoolModal'),
);

export default {
  CONFERENCE_SCHOOLS_MODAL: ConferenceSchoolsModal,
  FAVORITE_SCHOOL_MODAL: FavoriteSchoolModal,
};
